enum SensorStatus {
  Ok = 'OK',
  Error = 'ERROR'
}

export default SensorStatus;
